module.exports = __webpack_public_path__ + "static/img/pdd.4fce0128.jpg";